import type { FinancialInstrument } from '../players/types';
import type { AFSBondMarketReplacement } from './types';

export const filterPlayerMarketInstruments = (
  instruments: FinancialInstrument[],
  switchoverEnabled: boolean,
  replacements: AFSBondMarketReplacement[] = [],
): FinancialInstrument[] => {
  instruments = instruments.filter(instrument => instrument.live_bond_market_visible !== false);
  if (!switchoverEnabled || replacements.length === 0) return instruments;

  const outgoingAssetIds = new Set(
    replacements.map(replacement => replacement.outgoing_asset_id),
  );
  return instruments.filter(
    instrument => !outgoingAssetIds.has(instrument.underlying_asset),
  );
};

export const findAFSBondMarketReplacementInstrument = (
  outgoingInstrument: FinancialInstrument | undefined,
  visibleInstruments: FinancialInstrument[],
  replacements: AFSBondMarketReplacement[] = [],
): FinancialInstrument | undefined => {
  if (!outgoingInstrument) return undefined;

  const replacement = replacements.find(
    item => item.outgoing_asset_id === outgoingInstrument.underlying_asset,
  );
  if (!replacement) return undefined;

  return visibleInstruments.find(
    instrument => instrument.underlying_asset === replacement.incoming_asset_id,
  );
};
